import * as Yup from 'yup';
export const teamLeadSchema = Yup.object().shape({
    jobTitle: Yup.string(),
    clinicId: Yup.string(),
});
//# sourceMappingURL=team-lead.js.map